import { render, staticRenderFns } from "./WalkingTravel.vue?vue&type=template&id=c518c0bc&scoped=true"
import script from "./WalkingTravel.vue?vue&type=script&lang=js"
export * from "./WalkingTravel.vue?vue&type=script&lang=js"
import style0 from "./WalkingTravel.vue?vue&type=style&index=0&id=c518c0bc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c518c0bc",
  null
  
)

export default component.exports